"use client";

import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-3d-printing";

const COLUMNS = [
	{ key: "Sla", label: "capabilitiesColSla" },
	{ key: "Mjf", label: "capabilitiesColMjf" },
	{ key: "Sls", label: "capabilitiesColSls" },
	{ key: "Fdm", label: "capabilitiesColFdm" },
] as const;

const ROWS = [
	{ key: "WallThickness", label: "capabilitiesRowWallThickness" },
	{ key: "LayerHeight", label: "capabilitiesRowLayerHeight" },
	{ key: "BuildSize", label: "capabilitiesRowBuildSize" },
	{ key: "Tolerance", label: "capabilitiesRowTolerance" },
	{ key: "LeadTime", label: "capabilitiesRowLeadTime" },
] as const;

export default function PrintingCapabilities() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#f6ffde] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 flex flex-col gap-4 sm:mb-8 md:mb-10 md:flex-row md:items-start md:justify-between md:gap-8 lg:mb-12 lg:gap-12">
					<h2 className="shrink-0 text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl lg:max-w-[620px]">
						<span className="block">{t("capabilitiesTitleLine1")}</span>
						<span className="mt-1 inline-flex items-center gap-3">
							{t("capabilitiesTitleLine2")}
							<span className="inline-block h-1 w-20 self-end bg-themePrimary400" />
						</span>
					</h2>
					<p className="text-sm leading-relaxed text-black md:min-w-0 md:flex-1 md:text-base lg:max-w-[580px]">
						{t("capabilitiesDesc")}
					</p>
				</header>

				<div className="overflow-x-auto">
					<table className="w-full min-w-[720px] border-collapse text-left">
						<thead>
							<tr>
								<th className="border-b border-[#c0c0bf] px-5 py-5 text-sm font-bold text-black md:px-6 md:py-6 md:text-base" />
								{COLUMNS.map((col) => (
									<th
										key={col.key}
										className="border-b border-[#c0c0bf] px-5 py-5 text-sm font-bold text-black md:px-6 md:py-6 md:text-base"
									>
										{t(col.label)}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{ROWS.map((row, rowIdx) => (
								<tr key={row.key}>
									<th
										scope="row"
										className="border-b border-[#c0c0bf] px-5 py-5 text-sm font-bold text-black md:px-6 md:py-6 md:text-base"
									>
										{t(row.label)}
									</th>
									{COLUMNS.map((col) => (
										<td
											key={col.key}
											className="border-b border-[#c0c0bf] px-5 py-5 align-top text-sm leading-relaxed text-black md:px-6 md:py-6 md:text-base"
										>
											{t(`capabilities${col.key}${row.key}`)}
										</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="mt-6 flex justify-center sm:mt-8">
					<Link
						href="/contact-us"
						className="inline-flex items-center gap-2 text-sm font-semibold text-themePrimary400 transition-colors duration-300 hover:text-[#83b751] md:text-base"
					>
						<span>{t("capabilitiesContactCta")}</span>
						<span aria-hidden="true">→</span>
					</Link>
				</div>
			</div>
		</section>
	);
}
